import React from 'react';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { Product } from 'types/product';

type ProductItemModuleProps = {
  product: Product;
};

const ProductItemModule: React.FC<ProductItemModuleProps> = ({ product }) => {
  return (
    <ModuleCard
      idLabel={`ID ${product.id}`}
      title={product.name}
      subtitle="Produto"
      fields={[
        { label: 'Fabricante', value: product.manufacturer },
        { label: 'Unidade', value: product.unit },
      ]}
      onClick={() => history.push(`/products/${product.id}`)}
    />
  );
};

export default ProductItemModule;
